const UserValidation = require('./userValidation');
const ResumeValidation = require('./resumeValidation');
const CoverLetterValidation = require('./coverLetterValidation');
const LoggingValidation = require('./loggingValidation');
const AuthValidation = require('./authValidation');
const indeedApiValidation = require('./indeedApiValidation');

module.exports = {
    UserValidation,
    ResumeValidation,
    CoverLetterValidation,
    LoggingValidation,
    AuthValidation,
    indeedApiValidation
};
